import { Box, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const ServiceItem = ({ data = [] }) => {
  const navigate = useNavigate();

  const location = useLocation();

  const handleWhatsApp = (title) => {
    trackEvent(`${title}_whatsapp`, {
      page_path: location.pathname,
      page_url: window.location.href,
      section: `${title}_WhatsApp`,
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      `Hola Centro Médico MEDAM 👋, me gustaría recibir información sobre ${title}.`,
      true,
    );
  };

  return (
    <Grid container>
      <Grid size={design.gridOne} />
      <Grid container size={design.grid10} mb={3}>
        <CustomText
          color="#782A9F"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.textNuestro}
        >
          Nuestros Servicios
        </CustomText>

        <CustomText
          color="#3A3A3A"
          fontWeight={400}
          fontFamily="Nunito"
          textAlign="justify"
          sx={design.textCentro}
        >
          En Centro Médico MEDAM, tu salud y la de tu familia son lo más
          importante. Nuestro compromiso es ofrecerte atención médica con
          profesionalismo, cercanía y calidad humana. Sabemos que cada paciente
          es único, por eso te acompañamos en cada paso, asegurándonos de que
          recibas la atención que mereces, siempre con empatía, calidez y
          dedicación.
        </CustomText>

        {data.map((service) => (
          <Grid key={service?.title} size={design.grid4}>
            <Box
              sx={{
                ...design.Card,
                "--service-color": service?.color,
              }}
            >
              {/* IMAGEN */}
              <Box sx={design.ImageContainer}>
                <ImageLoader
                  src={service?.image}
                  alt={service?.title}
                  width="100%"
                  height="100%"
                  objectPosition={service?.backgroundPosition}
                />
                {/* Degradado de esquina */}
                <Box sx={design.Gradient(service)} />
                {/* Curva blanca */}
                <Box sx={design.Wave} />
                {/* Título */}
                <CustomText
                  color={service?.color}
                  fontWeight={700}
                  fontFamily="Nunito"
                  sx={design.Title}
                >
                  {service?.title}
                </CustomText>
              </Box>

              {/* DESCRIPCIÓN */}
              <Box sx={design.Content}>
                <CustomText
                  color="#333"
                  fontFamily="Nunito"
                  textAlign="justify"
                  sx={design.Description}
                >
                  {service?.description}
                </CustomText>
                <Grid container sx={design.Actions}>
                  <CustomButton
                    width={"95%"}
                    height={40}
                    borderRadius={10}
                    backgroundColor="#65B12E"
                    colorTexto="#FFF"
                    fontFamily="Nunito"
                    fontSize={14}
                    variant="contained"
                    grid={6}
                    gridXS={12}
                    onClick={() => handleWhatsApp(service?.title)}
                  >
                    WhatsApp
                  </CustomButton>
                  <CustomButton
                    width={"95%"}
                    height={40}
                    borderRadius={10}
                    backgroundColor="#FFF"
                    colorTexto="#00518c"
                    border="1px solid #c2c2c2"
                    fontFamily="Nunito"
                    fontSize={14}
                    variant="contained"
                    grid={6}
                    gridXS={12}
                    onClick={() => navigate("/directorioMedico")}
                  >
                    Conoce más
                  </CustomButton>
                </Grid>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid size={design.gridOne} />
    </Grid>
  );
};

export default ServiceItem;

const design = {
  Card: {
    width: { xs: "98%", md: "90%" },
    borderRadius: "24px",
    overflow: "hidden",
    backgroundColor: "#FFF",
    border: "1px solid #E2E2E2",
    boxShadow: "0 2px 5px rgba(0,0,0,.08)",
    position: "relative",
    transition: "all .3s ease",
    my: 2,
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 8px 20px rgba(0,0,0,.12)",
    },
  },
  ImageContainer: {
    position: "relative",
    width: "100%",
    height: {
      xs: 155,
      md: 190,
    },
    overflow: "hidden",
  },

  Gradient: (service) => ({
    position: "absolute",
    width: 245,
    height: 245,
    borderRadius: "50%",
    top: -140,
    left: -140,
    zIndex: 0,
    background: `radial-gradient(
      circle,
      ${service?.color} 0%,
      ${service?.color} 42%,
      ${service?.color} 20%,
      rgba(255,255,255,0) 100%
    )`,
  }),
  Title: {
    position: "absolute",
    left: 16,
    bottom: 10,
    fontSize: {
      xs: 18,
      md: 20,
    },
    lineHeight: 1.2,
    "&::after": {
      content: '""',
      display: "block",
      width: "75%",
      height: "3px",
      marginTop: "5px",
      backgroundColor: "var(--service-color)",
      borderRadius: "5px",
    },
  },
  Content: {
    padding: {
      xs: "0px 15px 15px",
      md: "0px 15px 15px",
    },
  },
  Description: {
    fontSize: { xs: 16, md: 15 },
    lineHeight: "20px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: { xs: "auto", md: 7 },
    overflow: "hidden",
    textOverflow: "ellipsis",
    minHeight: {
      xs: "auto",
      md: 130,
    },
  },
  Actions: {
    py: 1,
    marginTop: 2,
    borderTop: "1px solid #E0E0E0",
    rowGap: 2,
  },
  textCentro: {
    fontSize: { xs: 20, md: 20 },
    pr: { xs: 1, md: 5 },
    pb: { xs: 1, md: 3 },
  },
  textNuestro: {
    marginY: 3,
    fontSize: { xs: 24, md: 40 },
  },
  Wave: {
    position: "absolute",
    left: "-5%",
    bottom: "-48px",
    width: "110%",
    height: "95px",
    backgroundColor: "#FFF",
    borderRadius: "30% 60% 0 0",
    transform: "rotate(3deg)",
  },
  gridOne: { xs: 0.5, sm: 1, lg: 1 },
  grid10: { xs: 11, sm: 10, lg: 10 },
  grid4: { xs: 12, sm: 6, lg: 4 },
};
